import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const HowItWorksSection = () => {
  const { t } = useLanguage();

  const steps = [
    {
      number: "01",
      icon: "UserPlus",
      title: t('howItWorks.step1Title'),
      description: t('howItWorks.step1Desc')
    },
    {
      number: "02",
      icon: "FileText",
      title: t('howItWorks.step2Title'),
      description: t('howItWorks.step2Desc')
    },
    {
      number: "03",
      icon: "Search",
      title: t('howItWorks.step3Title'),
      description: t('howItWorks.step3Desc')
    },
    {
      number: "04",
      icon: "UserCheck",
      title: t('howItWorks.step4Title'),
      description: t('howItWorks.step4Desc')
    }
  ];

  return (
    <section id="how-it-works" className="py-16 md:py-24 lg:py-32 bg-gradient-to-br from-gray-50 to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/60 backdrop-blur-xl border border-white/20 shadow-lg rounded-full mb-4 md:mb-6">
            <Icon name="Route" size={20} color="#0025cc" />
            <span className="text-sm md:text-base font-medium text-[#0025cc]">{t('howItWorks.badge')}</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#111827] mb-4">
            {t('howItWorks.title')}
          </h2>
          <p className="text-base md:text-lg text-[#6B7280] max-w-2xl mx-auto">
            {t('howItWorks.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {steps?.map((step, index) => (
            <div key={index} className="relative">
              <div 
                className="bg-white/40 backdrop-blur-xl border border-white/20 rounded-3xl p-6 md:p-8 shadow-xl hover:shadow-2xl hover:bg-white/50 transition-all duration-300 h-full"
                style={{
                  background: 'linear-gradient(135deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.2) 100%)'
                }}
              >
                <div className="flex items-center gap-4 mb-4 md:mb-6">
                  <span className="text-4xl md:text-5xl font-bold text-[#0025cc]/20">
                    {step?.number}
                  </span>
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-gradient-to-br from-[#0025cc] to-[#0025cc] flex items-center justify-center shadow-lg">
                    <Icon name={step?.icon} size={24} color="#FFFFFF" />
                  </div>
                </div>
                
                <h3 className="text-lg md:text-xl font-semibold text-[#111827] mb-3">
                  {step?.title}
                </h3>
                
                <p className="text-sm md:text-base text-[#6B7280] leading-relaxed">
                  {step?.description}
                </p>
              </div>
              
              {index < steps?.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                  <Icon name="ArrowRight" size={24} color="#E5E7EB" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;